export const de = {
    common: {
        cancel: 'Abbrechen',
        save: 'Speichern',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        create: 'Erstellen',
        loading: 'Laden…',
        copy: 'Kopieren',
        ok: 'OK',
        close: 'Schließen',
        or: 'oder',
        creating: 'Wird erstellt...',
        unknownError: 'Unbekannter Fehler',
        none: 'Keine',
        color: 'Farbe',
        visible: 'Sichtbar',
        locked: 'Gesperrt',
        hide: 'Ausblenden',
        show: 'Anzeigen',
        lock: 'Sperren',
        unlock: 'Entsperren',
        update: 'Aktualisieren',
    },
    language: {
        label: 'Sprache',
    },
    auth: {
        welcome: 'Willkommen bei tween.studio — gestalte Motion, baue Szenen und erwecke deine Geschichten zum Leben.',
        email: 'E-Mail',
        password: 'Passwort',
        emailPlaceholder: 'du@beispiel.com',
        name: 'Vorname',
        surname: 'Nachname',
        namePlaceholder: 'Ada',
        surnamePlaceholder: 'Lovelace',
        confirmPassword: 'Passwort bestätigen',
        termsOfService: 'Nutzungsbedingungen',
        privacyPolicy: 'Datenschutzrichtlinie',
        and: 'und',
        signInTitle: 'Anmelden',
        signInSubtitle: 'Mach dort weiter, wo du aufgehört hast.',
        signIn: 'Anmelden',
        signingIn: 'Anmeldung...',
        noAccount: 'Noch kein Konto?',
        signUp: 'Registrieren',
        loginFailed: 'Anmeldung fehlgeschlagen',
        googleSignInFailed: 'Google-Anmeldung fehlgeschlagen',
        googleSignInLoadFailed: 'Google-Anmeldung konnte nicht geladen werden',
        continueWithFacebook: 'Mit Facebook fortfahren',
        continueWithInstagram: 'Mit Instagram fortfahren',
        metaSignInComingSoon: '{brand}-Anmeldung nutzt Meta Login — Anbindung folgt. Der Anbieter kann im Admin konfiguriert werden.',
        createAccountTitle: 'Konto erstellen',
        createAccountSubtitle: 'Tritt tween.studio bei und starte mit Animation.',
        createAccount: 'Konto erstellen',
        creatingAccount: 'Konto wird erstellt...',
        hasAccount: 'Bereits ein Konto?',
        signInLink: 'Anmelden',
        termsAgreePrefix: 'Mit der Erstellung eines Kontos stimmst du unseren',
        termsAgreeSuffix: ' zu.',
        passwordMinLength: 'Das Passwort muss mindestens 6 Zeichen lang sein.',
        passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein.',
        registrationFailed: 'Registrierung fehlgeschlagen',
    },
    theme: {
        label: 'Design',
        light: 'Hell',
        dark: 'Dunkel',
        system: 'System',
        switchToLight: 'Zum hellen Modus wechseln',
        switchToDark: 'Zum dunklen Modus wechseln',
    },
    connection: {
        Connected: 'Verbunden',
        Connecting: 'Verbinden',
        Reconnecting: 'Wiederverbinden',
        Disconnected: 'Getrennt',
        Error: 'Fehler',
    },
    toolbar: {
        selectMovie: 'Film auswählen',
        ai: 'KI',
        notifications: 'Benachrichtigungen',
        loadingNotifications: 'Benachrichtigungen werden geladen...',
        noNotifications: 'Noch keine Benachrichtigungen.',
        zoom: 'Zoom',
        zoomLevel: 'Zoomstufe',
        zoomIn: 'Vergrößern',
        zoomOut: 'Verkleinern',
        zoomPercent: 'Zoom {percent}%',
        shapes: 'Formen',
        objects3d: '3D-Objekte',
        characters: 'Figuren',
        characterPresets: {
            humanoid: 'Mensch',
            animal: 'Tier',
            turtle: 'Schildkröte',
            octopus: 'Oktopus',
        },
        sceneEffects: 'Szeneneffekte',
        sceneEffectsLabel: 'Szeneneffekte',
        activeEffects: '{count} aktive Effekte',
        clearAllEffects: 'Alle Effekte löschen',
        tools: {
            select: 'Auswahl (V)',
            pan: 'Hand (H, Leertaste halten)',
            line: 'Linie (L)',
            curve: 'Kurve (P)',
            text: 'Text (T)',
            rectangle: 'Rechteck (R)',
            circle: 'Kreis (C)',
            triangle: 'Dreieck',
            polygon: 'Polygon (G)',
            cube3d: '3D-Würfel',
            sphere3d: '3D-Kugel',
            box3d: '3D-Box',
            cylinder3d: '3D-Zylinder',
            prism3d: '3D-Prisma',
            mesh3d: '3D-Mesh',
            fog: 'Nebel',
            rain: 'Regen',
            snow: 'Schnee',
            lightning: 'Blitz',
            particles: 'Partikel',
            vignette: 'Vignette',
        },
    },
    movieSelector: {
        newMovie: 'Neuer Film',
        createNewMovie: 'Neuen Film erstellen',
        movieNamePlaceholder: 'Filmname...',
        movieDescriptionPlaceholder: 'Filmbeschreibung...',
        recent: 'Zuletzt',
        myProjects: 'Meine Projekte',
        sampleMovies: 'Beispielfilme',
        currentMovie: 'Aktueller Film',
        unloadMovie: 'Film schließen',
        closeMovie: 'Film schließen',
        deleteMovie: 'Film löschen',
        moreActions: 'Weitere Aktionen',
        selectToPreview: 'Wählen Sie einen Film zur Vorschau',
        deleteConfirmTitle: 'Film löschen?',
        deleteConfirmDescription: '„{name}“ wird dauerhaft gelöscht.',
        thisMovie: 'Dieser Film',
        movieAria: 'Film',
        today: 'Heute',
        yesterday: 'Gestern',
        daysAgo: 'vor {count} Tagen',
        older: 'Älter',
        errors: {
            idUnresolved: 'Film-ID konnte nicht aufgelöst werden.',
            nameEmpty: 'Der Filmname darf nicht leer sein.',
            saveFailed: 'Film konnte nicht gespeichert werden. Bitte erneut versuchen.',
        },
    },
    userMenu: {
        ariaLabel: 'Benutzermenü',
        sectionsAria: 'Benutzermenü-Abschnitte',
        tabs: {
            credits: 'Credits',
            account: 'Konto',
            preferences: 'Einstellungen',
        },
        administration: 'Administration',
        signOut: 'Abmelden',
        loadingCredits: 'Credits werden geladen',
        creditsCount: '{count} Credits',
        credits: {
            currentBalance: 'Aktuelles Guthaben',
            unit: 'Credits',
            add: 'Credits hinzufügen',
            hideAdd: 'Credits hinzufügen ausblenden',
            hideAddOptions: 'Optionen zum Hinzufügen von Credits ausblenden',
            loadingPurchase: 'Kaufoptionen werden geladen...',
            noCardOptions: 'Keine Kartenzahlungsoptionen konfiguriert.',
            planCredits: '{count} Credits',
            loadWithTether: 'Mit Tether (USDT) aufladen',
            loadingDeposit: 'Laden...',
            noUsdtWallet: 'Keine USDT-Wallet-Adresse konfiguriert.',
            rate: '1 {symbol} = {credits} Credits',
            copyAddress: 'Adresse kopieren',
            recentTransactions: 'Letzte Transaktionen',
            loadingTransactions: 'Transaktionen werden geladen...',
            noTransactions: 'Noch keine Transaktionen.',
        },
        account: {
            creditUsage: 'Credit-Nutzung',
            balance: 'Guthaben',
            earned: 'Verdient',
            spent: 'Ausgegeben',
            transactions: 'Transaktionen',
            changePassword: 'Passwort ändern',
            changePasswordTitle: 'Passwort ändern',
            currentPassword: 'Aktuelles Passwort',
            currentPasswordHint: 'Für reine Social-Konten leer lassen',
            newPassword: 'Neues Passwort',
            confirmPassword: 'Neues Passwort bestätigen',
            updatePassword: 'Passwort aktualisieren',
            saving: 'Speichern…',
            errors: {
                newRequired: 'Neues Passwort ist erforderlich.',
                minLength: 'Neues Passwort muss mindestens 6 Zeichen haben.',
                mismatch: 'Neues Passwort und Bestätigung stimmen nicht überein.',
                failed: 'Passwort konnte nicht geändert werden.',
            },
            success: 'Passwort erfolgreich geändert.',
        },
    },
    sidebar: {
        collapse: 'Bereich einklappen',
        expand: 'Bereich ausklappen',
    },
    toolpads: {
        library: {
            title: 'Bibliothek',
            dropImages: 'Bilder hier ablegen',
            importFiles: 'Dateien importieren',
            import: '+ Importieren',
            importAria: 'Dateien importieren',
            uploading: 'Wird hochgeladen…',
            deleteConfirmTitle: 'Bibliothekselement löschen?',
            deleteConfirmDescription: '„{name}“ wird dauerhaft gelöscht.',
            deleteFailedTitle: 'Löschen fehlgeschlagen',
            deleteFailedFallback: 'Löschen fehlgeschlagen.',
            inUseTitle: 'Bibliothekselement wird verwendet',
            inUseDescription: '„{name}“ wird von mindestens einem Szenenobjekt verwendet ({count}). Entfernen Sie es zuerst aus der Szene.',
            noLayerTitle: 'Keine Ebene ausgewählt',
            noLayerDescription: 'Wählen Sie eine Ebene aus, bevor Sie ein Szenenobjekt hinzufügen.',
            mine: 'Projekt',
            vectorHint: 'Auf die Bühne ziehen oder doppelklicken, um es in dieses Projekt zu kopieren.',
            vectorsEmpty: 'Die öffentliche Bibliothek ist leer.',
            vectorsLoadFailed: 'Die öffentliche Bibliothek konnte nicht geladen werden.',
            vectorUseFailed: 'Bibliothekseintrag konnte nicht zum Projekt hinzugefügt werden.',
        },
        scenes: {
            title: 'Szenen',
            empty: 'Noch keine Szenen.',
            add: '+ Szene hinzufügen',
            defaultName: 'Szene {count}',
            nameAria: 'Szenenname',
            dragReorder: 'Zum Neuordnen ziehen',
            deleteTitle: 'Szene löschen',
            deleteDescription: '„{name}“ wird gelöscht.',
            deleteTooltip: 'Szene löschen',
            cannotDeleteTitle: 'Szene kann nicht gelöscht werden',
            cannotDeleteLast: 'Ein Film muss mindestens eine Szene behalten. Die letzte Szene kann nicht gelöscht werden.',
            createFailed: 'Szene konnte nicht erstellt werden: {error}',
            deleteFailed: 'Szene konnte nicht gelöscht werden: {error}',
        },
        sceneObjects: {
            title: 'Szenenobjekte',
            empty: 'Fügen Sie Objekte hinzu, indem Sie sie aus der Bibliothek ziehen.',
            selectAll: 'Alle auswählen',
            selectAllAria: 'Alle Szenenobjekte auswählen',
            selectedCount: '{count} ausgewählt',
            expand: 'Erweitern',
            collapse: 'Einklappen',
            objectNameAria: 'Objektname',
            selectObject: '{name} auswählen',
            selectObjectAndChildren: '{name} und untergeordnete Elemente auswählen',
            deselectObjectAndChildren: 'Auswahl von {name} und untergeordneten Elementen aufheben',
            selectAllChildren: 'Alle untergeordneten Elemente auswählen',
            all: 'Alle',
        },
        sceneEffects: {
            title: 'Szeneneffekte',
            empty: 'Aktivieren Sie Szeneneffekte in der Symbolleiste, um hier ihre Parameter anzupassen.',
            activeCount: '{count} aktiv',
            clearAll: 'Alle löschen',
            expand: 'Parameter erweitern',
            collapse: 'Parameter einklappen',
            enable: 'Effekt aktivieren',
            disable: 'Effekt deaktivieren',
            params: {
                intensity: 'Intensität',
                speed: 'Geschwindigkeit',
                particleSize: 'Partikelgröße',
                color: 'Farbe',
            },
        },
        clipFolders: {
            title: 'Clip-Ordner',
            empty: 'Keine Clip-Ordner.',
            add: '+ Ordner hinzufügen',
            defaultName: 'Ordner {count}',
            deleteTooltip: 'Ordner löschen',
        },
        movieProperties: {
            title: 'Filmeigenschaften',
            stageSize: 'Bühnengröße',
            width: 'B',
            height: 'H',
            frameRate: 'Bildrate',
            frameRateAria: 'Bildrate',
            fpsOption: '{count} FPS',
            info: 'Info',
            name: 'Name: ',
            scenes: 'Szenen: ',
            noMovie: 'Kein Film geladen.',
            publish: 'Veröffentlichen',
            publishing: 'Wird veröffentlicht…',
            publishHint: 'Erstellt einen schreibgeschützten Snapshot für den öffentlichen Player.',
            linkCopied: 'Player-Link kopiert.',
        },
    },
    rightSidebar: {
        style: {
            title: 'Stil',
            selectObject: 'Wählen Sie ein Objekt auf der Bühne, um Farben anzupassen.',
            shapeOrTextOnly: 'Stileinstellungen gelten für Form-, Text- und Bildobjekte.',
            text: 'Text',
            textColor: 'Textfarbe',
            fontSize: 'Schriftgröße',
            fontSizeAria: 'Schriftgröße',
            fontSizePxAria: 'Schriftgröße px',
            align: 'Ausrichten',
            textAlignAria: 'Textausrichtung',
            left: 'Links',
            center: 'Mitte',
            right: 'Rechts',
            justify: 'Blocksatz',
            colors: 'Farben',
            fill: 'Füllung',
            fillModeAria: 'Füllmodus',
            fillSolid: 'Farbe',
            fillGradient: 'Verlauf',
            fillColor: 'Füllfarbe',
            gradientStart: 'Start',
            gradientEnd: 'Ende',
            gradientAngle: 'Winkel',
            gradientAngleAria: 'Verlaufswinkel',
            border: 'Rahmen',
            borderTypeAria: 'Rahmentyp',
            borderColor: 'Rahmenfarbe',
            borderSizeAria: 'Rahmengröße',
            size: 'Größe',
            sides: 'Seiten',
            sidesAria: 'Rahmenseiten',
            sideTop: 'Oben',
            sideRight: 'Rechts',
            sideBottom: 'Unten',
            sideLeft: 'Links',
            solid: 'Durchgezogen',
            dashed: 'Gestrichelt',
            dotted: 'Gepunktet',
            fillBorderConflict: 'Füllung und Rahmen können nicht gleichzeitig „keine“ sein.',
            effects: 'Effekte',
            shadow: 'Schatten',
            shadowColor: 'Schattenfarbe',
            shadowOffsetX: 'Versatz X',
            shadowOffsetY: 'Versatz Y',
            shadowBlur: 'Unschärfe',
            shadowSpread: 'Ausbreitung',
            glow: 'Leuchten',
            glowColor: 'Leuchtfarbe',
            glowBlur: 'Leuchtunschärfe',
            enabled: 'An',
            disabled: 'Aus',
        },
        properties: {
            title: 'Eigenschaften',
            object: 'Objekt',
            tween: 'Tween',
            transform: 'Transformation',
            stageTools: 'Bühnenwerkzeuge',
            stageResize: 'Resize',
            stageRotate: 'Rotate',
            stageResizeHint: 'Resize-Handles am ausgewählten Objekt anzeigen',
            stageRotateHint: 'Eck-Rotate-Handles und Pivot am ausgewählten Objekt anzeigen',
            pivotHint: 'Drehpunkt / Gelenk ziehen',
            keepAspectRatio: 'Seitenverhältnis beibehalten',
            keepAspectRatioHint: 'Wird beim Resize mit Shift auch vorübergehend aktiviert.',
            appearance: 'Darstellung',
            rotation: 'Drehung',
            rotationAria: 'Drehung',
            rotationDegreesAria: 'Drehgrade',
            opacity: 'Deckkraft',
            opacityAria: 'Deckkraft',
            opacityPercentAria: 'Deckkraft in Prozent',
            visibility: 'Sichtbarkeit',
            activeTween: 'Aktiver Tween ({start} → {end})',
            easing: 'Easing',
            easingAria: 'Easing-Typ',
            linear: 'Linear',
            easeIn: 'Ease In',
            easeOut: 'Ease Out',
            easeInOut: 'Ease In-Out',
            bounce: 'Bounce',
            elastic: 'Elastic',
            back: 'Back',
            noTween: 'Kein Tween am aktuellen Frame.',
            noTweenHint: 'Erstellen Sie zwei Keyframes und fügen Sie dazwischen einen Tween hinzu.',
            allTweens: 'Alle Tweens',
            frameRange: 'Frame {start} → {end}',
            noSelection: 'Wählen Sie etwas auf der Szene oder Timeline, um Eigenschaften anzuzeigen und zu bearbeiten.',
            selectedObjects: '{count} Objekte ausgewählt',
            selectedObjectAria: 'Zu bearbeitendes Objekt in der Auswahl',
            keyframe: 'Keyframe',
            frame: 'Frame:',
            activeKeyframe: '◆ Aktiver Keyframe: Frame {frame}',
            noKeyframe: 'Kein Keyframe am oder vor dem aktuellen Frame',
            selectFrameHint: 'Wählen Sie einen Frame in der Timeline',
            createKeyframe: 'Keyframe erstellen',
            updateKeyframe: 'Keyframe aktualisieren',
            stateObjects: 'Objekte mit State',
            noStateObjects: 'Dieser Keyframe trägt keinen Objekt-State.',
            copyStateToPrevious: 'State zum vorherigen Keyframe kopieren ({frame})',
            copyStateToNext: 'State zum nächsten Keyframe kopieren ({frame})',
            noPreviousKeyframe: 'Kein vorheriger Keyframe',
            noNextKeyframe: 'Kein nächster Keyframe',
        },
        align: {
            title: 'Ausrichten',
            horizontal: 'Horizontal',
            vertical: 'Vertikal',
            left: 'Links ausrichten',
            center: 'Zentrieren',
            right: 'Rechts ausrichten',
            top: 'Oben ausrichten',
            middle: 'Mitte ausrichten',
            bottom: 'Unten ausrichten',
        },
    },
    timeline: {
        prevFrame: 'Vorheriger Frame (,)',
        pause: 'Pause (Space)',
        play: 'Abspielen (Space)',
        playNeedsKeyframe: 'Zum Abspielen ist mindestens ein Keyframe erforderlich',
        stop: 'Stopp (.)',
        nextFrame: 'Nächster Frame (.)',
        addKeyframe: 'Keyframe hinzufügen (F6)',
        deselectKeyframe: 'Keyframe abwählen, um am Playhead hinzuzufügen',
        keyframeExists: 'Am aktuellen Frame existiert bereits ein Keyframe',
        deleteKeyframe: 'Keyframe löschen',
        addTween: 'Tween hinzufügen (F7)',
        addTweenHint: 'Kann zwischen zwei Keyframes hinzugefügt werden, wenn kein Tween existiert',
        deleteTween: 'Tween löschen',
        frame: 'Frame:',
        time: 'Zeit:',
        total: 'Gesamt:',
        totalFramesAria: 'Gesamtframes',
        addLayer: 'Ebene hinzufügen',
        newLayer: 'Neue Ebene',
        dragReorder: 'Zum Neuordnen ziehen',
        deleteLayer: 'Ebene löschen',
        cannotDeleteTitle: 'Ebene kann nicht gelöscht werden',
        cannotDeleteLast: 'Eine Szene muss mindestens eine Ebene behalten. Die letzte kann nicht gelöscht werden.',
        cannotDeleteNonEmpty: 'Diese Ebene ist nicht leer. Löschen Sie zuerst Keyframes, Tweens und Szenenobjekte.',
        tweenTitle: 'Tween: {start} - {end} ({easing})',
        frameTitle: 'Frame {frame}',
        frameDeleting: 'Frame {frame} (wird gelöscht...)',
        addKeyframeAt: 'Keyframe hinzufügen (Frame {frame})',
        addTweenShort: 'Tween hinzufügen',
        clearAllKeyframes: 'Alle Keyframes löschen',
        clearAllTweens: 'Alle Tweens löschen',
    },
    stage: {
        selectionToolbar: 'Objektaktionen',
        duplicate: 'Duplizieren',
        createGroup: 'Gruppe erstellen',
        createPattern: 'Muster erstellen',
        ungroup: 'Gruppe auflösen',
        removeFromGroup: 'Aus Gruppe entfernen',
        groupName: 'Gruppe',
        insideThisLayer: 'Innerhalb dieser Ebene',
        bringToFront: 'In den Vordergrund',
        bringForward: 'Nach vorne',
        sendBackward: 'Nach hinten',
        sendToBack: 'In den Hintergrund',
        sendToLayer: 'Auf Ebene senden',
        sendInto: 'Hinein senden',
        noSendIntoTargets: 'Keine Objekte auf dieser Ebene',
        objectFallback: 'Objekt {id}',
        noLayers: 'Keine Ebenen',
        layerFallback: 'Ebene {id}',
        noLayerTitle: 'Keine Ebene ausgewählt',
        noLayerDescription: 'Wählen Sie zuerst eine Ebene, um ein Szenenobjekt hinzuzufügen.',
    },
    welcome: {
        title: 'Willkommen',
        subtitle: 'Sie können ein neues Projekt erstellen oder ein kürzlich verwendetes auswählen.',
        createProject: 'Neues Projekt erstellen',
        projectNamePlaceholder: 'Projektname...',
        recentlyUsed: 'Zuletzt verwendet',
        noRecent: 'Keine kürzlich verwendeten Projekte',
        myProjects: 'Meine Projekte',
        sampleProjects: 'Beispielprojekte',
        empty: 'Noch keine Projekte. Erstellen Sie ein neues Projekt!',
        movieAria: 'Film',
        previewTitle: 'Vorschau',
        openProject: 'Projekt öffnen',
        noDescription: 'Keine Beschreibung',
        resolution: 'Auflösung',
        fps: 'Bildrate',
        fpsValue: '{fps} fps',
        scenes: 'Szenen',
        sceneObjects: 'Szenenobjekte',
        layers: 'Ebenen',
        sampleBadge: 'Beispiel',
    },
    aiChat: {
        deleteMessage: 'Nachricht löschen',
        thinking: 'Denkt nach...',
        jobs: 'Jobs',
        actions: 'Aktionen',
        payloads: 'Payloads',
        executionResults: 'Ausführungsergebnisse',
        loading: 'Laden...',
        resizePanel: 'Chat-Panel skalieren',
        selectConversation: 'Unterhaltung auswählen',
        newChat: 'Neuer Chat',
        newChatTooltip: 'Neuer Chat',
        deleteConversation: 'Unterhaltung löschen',
        debugOn: 'Debug-Modus an',
        debugOff: 'Debug-Modus aus',
        placeholder: 'Beschreiben Sie eine Szene ...',
        send: 'Senden',
    },
    admin: {
        badge: 'Admin',
        backToEditor: 'Zurück zum Editor',
        topbarTitle: 'Admin',
        a11y: {
            closeNav: 'Navigation schließen',
            openNav: 'Navigation öffnen',
        },
        nav: {
            dashboard: 'Dashboard',
            users: 'Benutzer',
            projects: 'Projekte',
            activity: 'Aktivität',
            activityDesc: 'SignalR · Protokoll',
            activityTitle: 'Live-SignalR-Verbindungen und Aktivitätsprotokoll',
            storageProviders: 'Speicheranbieter',
            socialProviders: 'Social Login',
            ai: 'KI',
            providers: 'Anbieter',
            prompts: 'Prompts',
            payment: 'Zahlung',
            cryptoWallets: 'Krypto-Wallets',
            disclaimers: 'Haftungsausschlüsse',
            install: 'Installation',
            analytics: 'Analytik',
            settings: 'Einstellungen',
            vectorPackages: 'Öffentliche Bibliothek',
        },
        vectorPackages: {
            title: 'Öffentliche Bibliothek',
            description: 'Plattformbibliothek für jedes Projekt. Git-Repository importieren oder ein Zip hochladen. Jeder Ordner wird ein eigenes Paket.',
            name: 'Paketname',
            file: 'Paketdatei',
            fileHint: 'Zip, SVG, PNG, WebP oder JPEG. Ein Zip wird in einzelne Dateien entpackt.',
            upload: 'Paket hochladen',
            uploading: 'Wird hochgeladen…',
            empty: 'Die öffentliche Bibliothek ist leer.',
            files: '{count} Dateien',
            delete: 'Löschen',
            preview: 'Dateien',
            hide: 'Ausblenden',
            deleteConfirm: '"{name}" und die Dateien löschen?',
            uploadFailed: 'Upload fehlgeschlagen.',
            deleteFailed: 'Paket konnte nicht gelöscht werden.',
            nameRequired: 'Paketname ist erforderlich.',
            fileRequired: 'Wählen Sie eine Paketdatei.',
            loadFailed: 'Die öffentliche Bibliothek konnte nicht geladen werden.',
            gitUrl: 'Repository-URL',
            gitBranch: 'Branch',
            gitPath: 'Ordner',
            gitFormat: 'Format',
            formatSvg: 'SVG',
            formatPng: 'PNG',
            gitHint: 'Nur HTTPS. Ein Ordner wie kits ergibt ein Paket je Unterordner. SVG und PNG werden nicht zusammen importiert. Ein erneuter Import aktualisiert dieselben Pakete.',
            gitImport: 'Repository importieren',
            gitImporting: 'Wird importiert…',
            gitImported: '{count} Pakete importiert.',
            gitFailed: 'Repository konnte nicht importiert werden.',
            gitUrlRequired: 'Repository-URL ist erforderlich.',
        },
    },
};
